import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";

const ToggleMenuButton = ({
  handleDrawerToggle,
  isInDrawerIcon
}: {
  handleDrawerToggle: () => void;
  isInDrawerIcon: boolean;
}) => (
  <IconButton
    aria-label={isInDrawerIcon ? "close settings" : "open settings"}
    onClick={handleDrawerToggle}
    sx={{
      color: "#e2e8f0",
      border: "1px solid #404754",
      backgroundColor: "#2c3139",
      "&:hover": {
        backgroundColor: "#404754"
      }
    }}>
    {isInDrawerIcon ? <CloseIcon /> : <MenuIcon />}
  </IconButton>
);

export default ToggleMenuButton;
